"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetStopPlace = createGetStopPlace;
exports.createGetStopPlaces = createGetStopPlaces;
exports.createGetParentStopPlace = createGetParentStopPlace;
exports.createGetStopPlacesByPosition = createGetStopPlacesByPosition;
exports.createGetStopPlaceFacilities = createGetStopPlaceFacilities;
exports.createGetQuaysForStopPlace = createGetQuaysForStopPlace;

var _api = require("../api");

var _query = require("./query");

var _utils = require("../utils");

var _config = require("../config");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function createGetStopPlace(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getStopPlace(stopPlaceId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _params$includeUnused = params.includeUnusedQuays,
        includeUnusedQuays = _params$includeUnused === void 0 ? true : _params$includeUnused,
        rest = _objectWithoutProperties(params, ["includeUnusedQuays"]);

    var variables = _objectSpread({
      id: stopPlaceId,
      filterByInUse: !includeUnusedQuays
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getStopPlaceQuery, variables, config).then(function (data) {
      return data === null || data === void 0 ? void 0 : data.stopPlace;
    });
  };
}

function createGetStopPlaces(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getStopPlaces(stopPlaceIds) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!Array.isArray(stopPlaceIds)) {
      throw new Error("getStopPlaces takes an array of strings, but got ".concat(_typeof(stopPlaceIds)));
    }

    if (stopPlaceIds.length === 0) {
      return Promise.resolve([]);
    }

    var _params$includeUnused2 = params.includeUnusedQuays,
        includeUnusedQuays = _params$includeUnused2 === void 0 ? true : _params$includeUnused2,
        rest = _objectWithoutProperties(params, ["includeUnusedQuays"]);

    var variables = _objectSpread({
      ids: stopPlaceIds,
      filterByInUse: !includeUnusedQuays
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getStopPlacesQuery, variables, config).then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.stopPlaces) || [];
    }).then(function (stopPlaceDetails) {
      return (0, _utils.forceOrder)(stopPlaceDetails, stopPlaceIds, function (_ref) {
        var id = _ref.id;
        return id;
      });
    });
  };
}

function createGetParentStopPlace(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getParentStopPlace(stopPlaceId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _params$includeUnused3 = params.includeUnusedQuays,
        includeUnusedQuays = _params$includeUnused3 === void 0 ? true : _params$includeUnused3,
        rest = _objectWithoutProperties(params, ["includeUnusedQuays"]);

    var variables = _objectSpread({
      id: stopPlaceId,
      filterByInUse: !includeUnusedQuays
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getParentStopPlaceQuery, variables, config).then(function (data) {
      var _data$stopPlace;

      return data === null || data === void 0 ? void 0 : (_data$stopPlace = data.stopPlace) === null || _data$stopPlace === void 0 ? void 0 : _data$stopPlace.parent;
    });
  };
}

function createGetStopPlacesByPosition(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getStopPlacesByPosition(coordinates) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _params$includeUnused4 = params.includeUnusedQuays,
        includeUnusedQuays = _params$includeUnused4 === void 0 ? true : _params$includeUnused4,
        rest = _objectWithoutProperties(params, ["includeUnusedQuays"]);

    var variables = _objectSpread(_objectSpread({}, (0, _utils.convertPositionToBbox)(coordinates, distance)), {}, {
      filterByInUse: !includeUnusedQuays
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getStopPlacesByBboxQuery, variables, config).then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.stopPlacesByBbox) || [];
    });
  };
}

function createGetStopPlaceFacilities(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getStopPlaceFacilities(stopPlaceId) {
    var variables = {
      id: stopPlaceId
    };
    return (0, _api.nsrQuery)(_query.getStopPlaceFacilitiesQuery, variables, config);
  };
}

function createGetQuaysForStopPlace(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getQuaysForStopPlace(stopPlaceId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _params$includeUnused5 = params.includeUnusedQuays,
        includeUnusedQuays = _params$includeUnused5 === void 0 ? true : _params$includeUnused5,
        rest = _objectWithoutProperties(params, ["includeUnusedQuays"]);

    var variables = _objectSpread({
      id: stopPlaceId,
      filterByInUse: !includeUnusedQuays
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getQuaysForStopPlaceQuery, variables, config).then(function (data) {
      var _data$stopPlace2;

      return (data === null || data === void 0 ? void 0 : (_data$stopPlace2 = data.stopPlace) === null || _data$stopPlace2 === void 0 ? void 0 : _data$stopPlace2.quays) || [];
    });
  };
}